import { API } from "../utils";

export const getSupplierAPI = async () => {
    const response = await API.get("GetSuppliers");
    return response.data;
  };

